import styled from 'styled-components';

import { getPurpurColor, getPurpurTypography, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type WrapperProps = {
    $bottomOffset: string;
};

export const StickyWrapper = styled.aside<WrapperProps>`
    position: fixed;
    right: 1.25rem;
    bottom: ${({ $bottomOffset }) => `calc(1.25rem + ${$bottomOffset})`};
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    transition: bottom 0.5s ease-in-out;
    z-index: 101;
`;

// TODO: these button styles are copied from packages/@assets/resources/sass/modules/molecules/_sticky-navigation-footer.scss and adapted for styled-components.
// Change this when actions style will be updated globally

type ActionProps = {
    $isTransparent: boolean;
    $isHidden: boolean;
};

export const ActionContainer = styled.div<ActionProps>`
    text-align: right;
    transition: opacity 0.2s ease-in-out;
    opacity: ${({ $isTransparent }) => (!$isTransparent ? '1.0' : '0.0')};
    display: ${({ $isHidden }) => (!$isHidden ? 'block' : 'none')};
`;

export const ActionButtonTitle = styled.span`
    display: none;
    padding-left: 0.9375rem;
    font-size: 0.875rem;
`;

export const StyledActionButton = styled.button`
    position: relative;
    display: inline-block;
    margin: 0;
    padding: 0;
    max-width: 100%;
    background-color: ${getPurpurColor('functionalWhite')};
    color: ${getPurpurColor('purple500')};
    text-align: center;
    font-size: 0.9375rem;
    font-weight: ${getPurpurTypography('weightBold')};
    line-height: 1.125rem;
    border-radius: 40px;
    border: 1px solid transparent;
    text-decoration: none;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
    transition:
        color 0.15s ease-in-out,
        background-color 0.15s ease-in-out;
    cursor: pointer;
    z-index: 100;

    &:hover,
    &:focus {
        color: ${getPurpurColor('functionalWhite')};
        outline: 0;
    }

    &:hover {
        background-color: #c0f;

        ${purpurMedia('md')`
            ${ActionButtonTitle} {
                display: inline-block;
            }
        `};
    }

    &:focus {
        background-color: #9b009b;
    }
`;
export const ActionButtonIcon = styled.span`
    display: inline-block;
    text-align: center;
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    font-size: 0.875rem;

    ${purpurMedia('md')`
        width: 2.375rem;
        height: 2.375rem;
        line-height: 2.375rem;
    `};

    .icon {
        display: inline-block;
        font-size: 1.3125rem;
        line-height: 3rem;
        margin: 0;
        transition: none;
        vertical-align: middle;

        ${purpurMedia('md')`
            font-size: 1.125rem;
            line-height: 2.375rem;
        `};
    }
`;

export const BadgeCount = styled.sup`
    align-items: center;
    background-color: #ff00cd;
    border-radius: 50%;
    color: ${getPurpurColor('functionalWhite')};
    display: flex;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: ${getPurpurTypography('weightNormal')};
    justify-content: center;
    line-height: 1.25rem;
    min-width: 1.25rem;
    position: absolute;
    right: -0.3125rem;
    top: -0.3125rem;

    ${purpurMedia('md')`
        font-size: 0.875rem
    `};
`;
